import { render, staticRenderFns } from "./tupian.vue?vue&type=template&id=697ea8a3&"
import script from "./tupian.vue?vue&type=script&lang=ts&"
export * from "./tupian.vue?vue&type=script&lang=ts&"
import style0 from "./tupian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports